<div class="raw-select container">
	<div class="row">
		<label class="col-sm-2 col-form-label">Date: </label>
		<div class="col-sm-4">
			<app-day-picker [(ngModel)]="selectedDate" (ngModelChange)="dateChange()" [allowedDates]="allowedDates"></app-day-picker>
		</div>
		<label class="col-sm-2 col-form-label">Acquisition: </label>
		<div *ngIf="rawids && rawids.length" class="col-sm-4">
			<select class="form-control form-control-sm" [ngModel]="selected" (ngModelChange)="rawChange($event)">
        <option *ngFor="let raw of rawids" [ngValue]="raw">{{raw.ts | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</option>
      </select>
		</div>
		<div *ngIf="!rawids || !rawids.length" class="col-sm-4 col-form-label">
			No acquisitions available
		</div>
	</div>
</div>